import React from 'react';
import { Routing } from '@singularsystems/neo-react';
import { AppTypes, AppService } from '../../Services/AppService';
import { IAppRoute } from '../../Services/RouteService';

import TermsAndConditionsView from 'st-common/Identity/Views/TermsAndConditionsView';
import { ProxyAsParticipantModal } from 'st-common/Identity';

class RouteView extends Routing.RouteView {
    
    private authService = AppService.get(AppTypes.Shared.Services.STAuthenticationService);
    private termsAndConditionsService = AppService.get(AppTypes.Identity.Services.TermsAndConditionsService);

    public static taskRunner = AppService.get(AppTypes.Neo.TaskRunner);

    constructor(props: any) {
        super(props, AppService.get(AppTypes.Shared.Services.RouteService).routes);

        this.getForbiddenComponent = (route) => <h2>Forbidden</h2>;
        this.getSigningInComponent = (route) => <div>Signing in...</div>;
    }

    protected isAuthorised(route: IAppRoute) {
        return super.isAuthorised(route);
    }

    protected getAuthorisedComponent(route: IAppRoute, path: string) {        

        if (!route.allowAnonymous && !this.termsAndConditionsService.userHasAccepted) {
            return <TermsAndConditionsView />
        } 

        if (!route.allowAnonymous && route.requiresParticipant !== false && !this.authService.user?.participantId) {
            return <ProxyAsParticipantModal taskRunner={RouteView.taskRunner} reloadOnProxy />;
        } 

        return super.getAuthorisedComponent(route, path);
    }
}

export default RouteView;